import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios, publicAxios } from "../api";

export const fetchTirms = createAsyncThunk(
  "tirms/fetchTirms",
  async (type, { rejectWithValue }) => {
    try {
      const response = await publicAxios.post(
        `/api/tirms`,
        { type },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data.politecs;
    } catch (error) {
      console.error("Error fetching tirms", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch tirms"
      );
    }
  }
);

export const AcceptTirms = createAsyncThunk(
  "tirms/AcceptTirms",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(`/api/user/terms_accept`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error accept tirms", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to accept tirms"
      );
    }
  }
);

const initialState = {
  tirms: [],
  acceptTerm: [],
  status: "idle",
  error: null,
};

const getTirmsSlice = createSlice({
  name: "tirms",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTirms.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchTirms.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.tirms = action.payload;
      })
      .addCase(fetchTirms.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(AcceptTirms.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(AcceptTirms.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.acceptTerm = action.payload;
      })
      .addCase(AcceptTirms.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default getTirmsSlice.reducer;
